import React from "react";
import BaseColumn from "../../sisu/layout/BaseColumn.sisu";

const NeoFlexColumn = (props) => {
    return (<BaseColumn custom="p-col p-d-flex p-flex-column" {...props}>{props.children}</BaseColumn>);
};

export default NeoFlexColumn;